
import { defineComponent} from "vue";
import HomeNavOption from "./HomeNavOption.vue";

export default defineComponent({
    name: "home",
    components:{
        HomeNavOption
    },
    setup() {
    }
});
